var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.availability)?_c('span',{class:_vm.classes},[_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }